import { cn } from "@/lib/utils";
import type { EvidenceKind } from "../../data";

// Tone pair per evidence label (the preview's green / blue / amber / orange).
export const evidenceToneClass: Record<EvidenceKind, string> = {
  V: "bg-tone-mint text-tone-mint-ink",
  F: "bg-tone-sky text-tone-sky-ink",
  I: "bg-tone-sun text-tone-sun-ink",
  O: "bg-tone-peach text-ink",
};

// The coloured top edge of an evidence card.
export const evidenceBorderClass: Record<EvidenceKind, string> = {
  V: "border-tone-mint-ink",
  F: "border-tone-sky-ink",
  I: "border-tone-sun-ink",
  O: "border-primary",
};

interface EvidenceTagProps {
  kind: EvidenceKind;
  label: string;
}

// The small uppercase label on every claim ("Verified data", "Fydo view").
const EvidenceTag = ({ kind, label }: EvidenceTagProps) => (
  <span
    className={cn(
      "inline-block w-fit justify-self-start rounded-full px-2.5 py-[3px] text-[11.5px] font-extrabold tracking-[0.06em] uppercase",
      evidenceToneClass[kind],
    )}
  >
    {label}
  </span>
);

export default EvidenceTag;
